<ng-container *ngIf="!loaded else displayUserProfile">
    <div class="py-3 text-center">
        <app-loader></app-loader>
    </div>
</ng-container>
<ng-template #displayUserProfile>
    <div class="row g-4 mt-2">
        <div class="col-12 d-flex justify-content-center align-items-start gap-4">
            <!-- Profile picture -->
            <div class="text-center">
                <div class="d-flex position-relative justify-content-center align-items-center">
                    <ng-container *ngIf="ppLoading else displayProfilePicture">
                        <div class="py-4 text-center">
                            <app-loader></app-loader>
                        </div>
                    </ng-container>
                    <ng-template #displayProfilePicture>
                        <app-picture
                            *ngIf="user"
                            [picture]="user?.picture"
                            [default]="user.initials"
                            size="100"
                            format="circle"
                        ></app-picture>
                        <button type="button" class="btn btn-sm change-picture" (click)="changeProfilePicture()">
                            <i class="bi bi-arrow-repeat"></i>
                        </button>
                    </ng-template>
                </div>
                <h4 class="mt-2 mb-0 p-0">{{ user.fullname }}</h4>
            </div>
            <div class="text-center" *ngIf="loaded && company">
                <div class="text-center">
                    <app-picture [picture]="company.picture" [default]="company.initials" size="100" format="circle"></app-picture>
                    <h4 class="mt-2 mb-0 p-0">{{ company.name }}</h4>
                </div>
            </div>
        </div>
    </div>
    <div class="row g-4 mt-5">
        <div class="col-12 text-center" [ngClass]="{'col-lg-8': todoList, 'col-lg-12': !todoList}">
            <div class="row g-4 align-items-stretch" *ngIf="tabs">
                <div class="col-4" *ngFor="let tab of tabs" [ngClass]="{'col-lg-3': todoList, 'col-lg-2': !todoList}">
                    <a
                        class="card px-2 text-center py-3 h-100 d-flex flex-column justify-content-center align-items-center"
                        [routerLink]="tab.path"
                        routerLinkActive="active"
                    >
                        <i class="bi bi-{{ tab.icon }} fs-1"></i>
                        <h6 class="m-0 p-0 pt-2">{{ tab.name|translate }}</h6>
                    </a>
                </div>
                <div class="col-4" [ngClass]="{'col-lg-3': todoList, 'col-lg-2': !todoList}">
                    <div
                        class="card clickable px-2 text-center py-3 h-100 d-flex flex-column justify-content-center align-items-center"
                        (click)="logout()"
                    >
                        <i class="bi bi-box-arrow-right fs-1 text-danger"></i>
                        <h6 class="m-0 p-0 pt-2 text-muted">{{ 'Logout'|translate }}</h6>
                    </div>
                </div>
            </div>

            <!--    <h4 class="pt-4 pb-2">{{ 'Header'|translate }}</h4>-->
            <!--    <p>-->
            <!--      {{ 'user_header_explanation'|translate }}-->
            <!--    </p>-->
            <!--    <app-image-upload [loading]="ushLoading" [progress]="ushProgress" size="750x150">-->
            <!--      <app-picture *ngIf="user && user.searchHeader" [picture]="user.searchHeader" size="750x150"></app-picture>-->
            <!--    </app-image-upload>-->
            <!--    <button type="button" class="btn btn-primary px-3 mt-3" (click)="changeUserSearchHeader()">-->
            <!--      <i class="bi bi-pencil-fill me-2"></i> <span>{{ 'Change'|translate }}</span>-->
            <!--    </button>-->
        </div>
        <div class="col-12 col-lg-4" *ngIf="todoList">
            <div class="card p-3">
                <app-todo-list [todoList]="todoList"></app-todo-list>
                <app-validation-status [user]="user" [todoList]="todoList"></app-validation-status>
            </div>
        </div>
    </div>

    <div class="row g-4 mt-4 align-items-stretch" *ngIf="user?.type === 'personal'">
        <div class="col-12">
            <h2 class="text-center fs-4">Avrazya Corporate</h2>
        </div>
        <div class="col-12 col-md-6" *ngIf="pendingRequests.length === 0">
            <div class="card p-3 h-100 d-flex flex-column justify-content-between align-items-center">
                <h3>{{ 'Register your company'|translate }}</h3>
                <p class="text-center">{{ 'Register your company explanation'|translate }}</p>
                <button type="button" class="btn btn-primary px-4" (click)="openProModal()" *ngIf="user.type === 'personal'">
                    <i class="ti ti-briefcase me-2"></i>
                    <span>{{ 'Become pro'|translate }}</span>
                </button>
            </div>
        </div>
        <div class="col-12 col-md-6" *ngIf="pendingRequests.length === 0">
            <div class="card p-3 h-100 d-flex flex-column justify-content-between align-items-center">
                <h3>{{ 'Join'|translate }}</h3>
                <p class="text-center">{{ 'Join explanation'|translate }}</p>
                <div class="d-flex justify-content-center align-items-center gap-2" [formGroup]="companyCodeForm">
                    <input type="text" class="form-control" formControlName="code" />
                    <button type="button" class="btn btn-primary px-4" [disabled]="joiningCompany" (click)="joinCompany()">
                        <i class="ti ti-building-plus"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 offset-lg-4 offset-md-3" *ngIf="pendingRequests.length > 0">
            <div class="d-flex flex-column gap-2 justify-content-center align-items-center">
                <div *ngFor="let req of pendingRequests">
                    <app-team-account-request [request]="req"></app-team-account-request>
                </div>
            </div>
        </div>
    </div>

    <div class="separator my-4"></div>
    <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-link" (click)="openAnonymizeModal()">{{ 'Delete my account'|translate }}</button>
    </div>
</ng-template>
